import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCreditCardPaymentMethodStore = defineStore('CreditCardPaymentMethod', () => {
  const showSaveCard = ref(true)
  const saveCard = ref(true)
  const reservationMonth = ref('')
  const reservationId = ref('')

  function updateShowSaveCard(value) {
    showSaveCard.value = value
  }

  function updateSaveCard(value) {
    saveCard.value = value
  }

  function updateReservationMonth(value) {
    reservationMonth.value = value
  }

  function updateReservationId(value) {
    reservationId.value = value
  }

  return {
    showSaveCard,
    saveCard,
    reservationMonth,
    reservationId,

    updateShowSaveCard,
    updateSaveCard,
    updateReservationMonth,
    updateReservationId
  }
})
